export default {
  company_card: 'Карточка компании',
  company_name: 'Название компании',
  legal_address: 'Адрес',
  unp: 'УНП',
  bank_details: 'Банк',
  iban_account: 'IBAN счет',
  'contact_e-mail': 'Эл. адрес',
  contact_phone: 'Телефон',
  save: 'Сохранить',
  feedback: 'Обратная связь',
  message_subject: 'Заголовок',
  message_text: 'Сообщение',
  send: 'Отправить',
  personal_area: 'Личный кабинет',
  calculator_settings: 'Калькулятор',
  my_staff: 'Сотрудники',
  help: 'Помощь',
  one: 'Один',
  base: 'Базовый',
  standart: 'Стандарт',
  premium: 'Премиум',
  small_studios: 'Для маленьких<br> печатных студий',
  user: 'пользователь | пользователей',
  printing_machines: 'печатные машины | печатных машин',
  dollars_month: 'рублей / месяц',
  connect_packet: 'Подключить пакет',
  up_to: 'до',
  do_you_want_to_delete_user:
    'Вы уверены что хотите удалить этого сотрудника?',
  add_user: 'Добавить сотрудника',
  can_not_add_user_with_email:
    'Добавить сотрудника с этим эл. адресом невозможно',
  company_info_updated: 'Информация обновлена успешно',
  user_were_added: 'Сотрудник добавлен',
  user_were_deleted: 'Сотрудник удален',
  role_were_updated: 'Роль обнавлена успешно'
}
